module.exports = __webpack_public_path__ + "static/Raze-2324c2090c9b355ff6a005d7b7b2b479.png";